import GalleryIcon from "@assets/icons/icon_gallery.svg";
interface IViewPhotosButton {
  onClick: () => void;
}

const ViewPhotosButton = ({ onClick }: IViewPhotosButton): JSX.Element => {
  return (
    <button
      className="
        flex
        h-[2.5rem]
        min-w-[7.4375rem]
        items-center 
        justify-center
        rounded-full 
        bg-[#FFFCFC] 
        stroke-[#FF7557] 
        stroke-2 
        text-p13
        font-semibold 
        text-orange-100
        hover:bg-[#CC5E46]
        hover:stroke-white 
        hover:text-white
        desktop:h-[3rem]
        desktop:min-w-[9.9375rem]"
      onClick={onClick}
    >
      <div className="flex items-center gap-2 ">
        <GalleryIcon />
        <span className="hidden desktop:block">View Gallery</span>
        <span className="block: desktop:hidden">Gallery</span>
      </div>
    </button>
  );
};

export default ViewPhotosButton;
